import { render, staticRenderFns } from "./在线商城.vue?vue&type=template&id=84c195b6&scoped=true"
import script from "./在线商城.vue?vue&type=script&lang=js"
export * from "./在线商城.vue?vue&type=script&lang=js"
import style0 from "./在线商城.vue?vue&type=style&index=0&id=84c195b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c195b6",
  null
  
)

export default component.exports